/**
 * NCHS Urban-Rural Classification Scheme for Counties — county-level lookup.
 * Generated by data_raw/build_nchs.R from the NCHS 2023 scheme file.
 *
 * Value: integer 1–6 (six-level county classification):
 *   1 = Large central metro   2 = Large fringe metro
 *   3 = Medium metro          4 = Small metro
 *   5 = Micropolitan          6 = Noncore (most rural)
 *
 * Source: https://www.cdc.gov/nchs/data-analysis-tools/urban-rural.html
 */

let _data = null;
let _loadPromise = null;

export function loadNchsData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/nchs.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load NCHS data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getNCHSForCounty(stateFips, countyFips) {
  if (!_data) return null;
  const key = `${String(stateFips).padStart(2, "0")}${String(countyFips).padStart(3, "0")}`;
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const NCHS_LABELS = {
  1: "Large central metro",
  2: "Large fringe metro",
  3: "Medium metro",
  4: "Small metro",
  5: "Micropolitan",
  6: "Noncore",
};

export function getNCHSDescription(code) {
  if (code == null) return null;
  return NCHS_LABELS[code] ?? null;
}

const nchs = { loadNchsData, getNCHSForCounty, getNCHSDescription };
export default nchs;
